// REMINDER: DO NOT HARDCODE THE URL, OR ADD ANY FALLBACKS OR REDIRECT URLS, THIS BREAKS THE AUTH
import { useEffect, useRef, useState } from "react";
import { useNavigate } from "react-router-dom";
import axios from "axios";
import { useAuth } from "@/lib/auth";

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

export default function AuthCallback() {
  const navigate = useNavigate();
  const { refresh } = useAuth();
  const hasProcessed = useRef(false);
  const [error, setError] = useState("");

  useEffect(() => {
    if (hasProcessed.current) return;
    hasProcessed.current = true;
    const hash = window.location.hash || "";
    const params = new URLSearchParams(hash.replace(/^#/, ""));
    const sessionId = params.get("session_id");
    if (!sessionId) {
      navigate("/login", { replace: true });
      return;
    }
    (async () => {
      try {
        await axios.post(
          `${API}/auth/session`,
          { session_id: sessionId },
          { withCredentials: true },
        );
        await refresh();
        // Strip hash from URL and land on /admin
        window.history.replaceState({}, "", "/admin");
        navigate("/admin", { replace: true });
      } catch (err) {
        const detail = err?.response?.data?.detail || "Sign-in failed";
        setError(detail);
        setTimeout(() => navigate("/login", { replace: true, state: { error: detail } }), 1500);
      }
    })();
  }, [navigate, refresh]);

  return (
    <main className="min-h-screen bg-[#0F1F4E] text-[#F8F1D8] flex items-center justify-center px-6">
      <div className="text-center" data-testid="auth-callback">
        <div className="font-serif text-3xl mb-3">Signing you in…</div>
        {error ? (
          <p className="text-[#EAD584]">{error}</p>
        ) : (
          <p className="text-[#D6D6BD] text-sm">One moment.</p>
        )}
      </div>
    </main>
  );
}
